import { createFileRoute } from '@tanstack/react-router';

import { FeedbackScreen } from '../../features/feedback/feedback-screen';
import { FEEDBACK_PERMISSIONS } from '../../features/feedback/types';
import { RequirePermission } from '../../lib/session/guards';

export const Route = createFileRoute('/feedback/')({
  component: FeedbackPage,
});

/**
 * `/feedback` — bugs, ideas and security reports (MASTER_PLAN M11.10, FR-FEEDBACK-01,
 * rules §50).
 *
 * `feedback.submit` is held by every role, so this page is open to the whole clinic;
 * moderation inside it is `feedback.moderate` and is gated by the screen.
 */
function FeedbackPage() {
  return (
    <RequirePermission keys={[FEEDBACK_PERMISSIONS.submit]}>
      <FeedbackScreen />
    </RequirePermission>
  );
}
